import React from 'react';
import styled from 'styled-components';
import { COLORS, device } from '../../../../constants';
import { DescriptionElement } from './DescriptionElement';
import { DescriptionListItem } from '../../../../types/globalTypes';
import { Box, VerticalBox } from '../../../../components';
import { MotionYOffsetBlock } from '../../../../components/Motion';
interface DivProps extends React.HTMLProps<HTMLDivElement> {
  objList: DescriptionListItem[];
}

export const Description: React.FC<DivProps> = ({ objList, ...props }) => {
  return (
    <ProjectDescription>
      <VerticalBox>
        <Box>
          <DescriptionContainer {...props}>
            {objList.map((el, index: number) => (
              <DescriptionElement key={index} obj={el} />
            ))}
          </DescriptionContainer>
        </Box>
      </VerticalBox>
    </ProjectDescription>
  );
};
const ProjectDescription = styled.div`
  background-color: ${COLORS.WHITE};
`;
const DescriptionContainer = styled(MotionYOffsetBlock)`
  max-width: 1400px;
  margin: auto;
  display: grid;

  grid-template-columns: repeat(3, 1fr);
  column-gap: 100px;
  row-gap: 60px;
  @media screen and (${device.lg}) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (${device.md}) {
    column-gap: 40px;
    row-gap: 40px;
    padding: 20px 0;
  }
  @media screen and (${device.sm}) {
    gap: 20px;
  }
`;
